import { Skeleton } from "@flixbus/honeycomb-react";
import { Breakpoint, ResponsiveRenderer } from "@flixbus-phx/marketplace-common";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import * as css from "./RideActionsSummary.scss";

type Props = {
  countTotal?: number;
  countSelected?: number;
  loading: boolean;
};

const RideActionsSummary: React.FC<Props> = ({ countTotal, countSelected, loading }) => {
  if (loading) {
    return (
      <ResponsiveRenderer hidden={[Breakpoint.XL]}>
        <div className={css.wrapper}>
          <FormattedMessage id="ride.actions.summary.countTotal" />
          &nbsp;
          <Skeleton extraClasses={css.summarySkeleton} Elem="span" height="sm" />
        </div>
      </ResponsiveRenderer>
    );
  }

  return (
    <>
      <ResponsiveRenderer hidden={[Breakpoint.XXS, Breakpoint.XS, Breakpoint.SM, Breakpoint.MD, Breakpoint.LG]}>
        {countSelected && countSelected > 0 ? (
          <div className={css.wrapper}>
            <b data-id="selected">{countSelected}</b>
            &nbsp;
            <FormattedMessage id="ride.actions.summary.countSelected" />
          </div>
        ) : (
          <></>
        )}
      </ResponsiveRenderer>

      <ResponsiveRenderer hidden={[Breakpoint.XL]}>
        {countTotal && countTotal > 0 ? (
          <div className={css.wrapper}>
            <FormattedMessage id="ride.actions.summary.countTotal" />
            &nbsp;
            <b data-id="total">{countTotal}</b>
          </div>
        ) : (
          <></>
        )}
      </ResponsiveRenderer>
    </>
  );
};

export default RideActionsSummary;
